import { SearchField, LazySearchField } from 'components/common/SearchField';
import { useTranslator } from 'hooks/translator';
import { SetState } from 'types/react';

import { Box } from '@mui/material';
import { useRenderContext } from 'hooks/render';
import { FilterProps, SearchOptions } from '../LargeTable';
import { useEffect } from 'react';
import { useDebouncedState } from 'utils/utils';

type MenuSearchProps = {
  filterProps?: FilterProps
  filter: SearchOptions
  setFilter: SetState<SearchOptions>
  loading: boolean
  lazy: boolean
  onChange: (e: React.SyntheticEvent) => void
}

const MenuBarSearch = ({filter, setFilter, loading, onChange, lazy}: MenuSearchProps) => {
  const { t }     = useTranslator()
  const {context} = useRenderContext()
  const [searchValue, setSearchValue, setCurrentSearchValue] = useDebouncedState(filter.search_text, 500)

  useEffect(() => {
    setFilter((prev) => {
      return ({
      ...prev,
      search_text: searchValue,
      })}
    );
  }, [searchValue]);

  const searchProps = {
    autoFocus: context !== 'detail',
    value: filter.search_text,
    setValue: setSearchValue,
    setCurrentValue: setCurrentSearchValue,
    placeholder: t('filter.search') || "",
    loading: loading,
    onChange: onChange,
  }

    return (
      <Box style={{paddingLeft: "10px", paddingRight: "10px", width: "300px", alignSelf: "start"}} >
        {lazy ? <LazySearchField {...searchProps}/> : <SearchField {...searchProps}/>}
      </Box>
    )
}

export default MenuBarSearch